import { useEffect, useState, useSyncExternalStore } from 'react';
import { secondsUntil } from './format';

/** Đồng hồ tick mỗi `ms` – dùng cho đếm ngược và nhãn "GPS cũ". */
export function useNow(ms = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(t);
  }, [ms]);
  return now;
}

/** Đếm ngược tới `expiresAt`; có thể đồng bộ giờ server cho dữ liệu API. */
export function useCountdown(expiresAt: string | undefined, serverNow?: (localNow: number) => number): { seconds: number; expired: boolean } {
  const localNow = useNow(1000);
  const now = serverNow ? serverNow(localNow) : localNow;
  if (!expiresAt) return { seconds: 0, expired: false };
  const seconds = secondsUntil(expiresAt, now);
  return { seconds, expired: seconds <= 0 };
}

export function useDebounced<T>(value: T, ms = 250): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}

const subscribeOnline = (cb: () => void) => {
  window.addEventListener('online', cb);
  window.addEventListener('offline', cb);
  return () => { window.removeEventListener('online', cb); window.removeEventListener('offline', cb); };
};

/** Trạng thái mạng của thiết bị (navigator.onLine). */
export function useOnline(): boolean {
  return useSyncExternalStore(subscribeOnline, () => navigator.onLine, () => true);
}
